export enum TIMING {
    before_check_in = 'before_check_in',
    before_check_out = 'before_check_out',
    on_reservations = 'on_reservations',
    credit = 'credit',
}